(function () {
  /**
   * @ngdoc module
   * @name app.widgets.common.ie-eleven-notification
   * @description module that defines the ie-eleven-notification widget
   */
  angular.module('app.widgets.common.ie-eleven-notification', [
    'binky.core.lodash',
    'binky.core.storage-utils',
  ]);
})();
